<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const primaryCards = computed(() => [
  {
    icon: "i-lucide-compass",
    key: "independence",
    delay: "1",
  },
  {
    icon: "i-lucide-sparkles",
    key: "worlds",
    delay: "2",
  },
  {
    icon: "i-lucide-route",
    key: "journeys",
    delay: "3",
  },
]);

const secondaryItems = computed(() => [
  { icon: "i-lucide-infinity", key: "progress", delay: "3" },
  { icon: "i-lucide-globe", key: "languages", delay: "3" },
  { icon: "i-lucide-puzzle", key: "setup", delay: "4" },
  { icon: "i-lucide-shield", key: "data", delay: "4" },
]);
</script>

<template>
  <section id="why-cresci" class="bg-[var(--color-bg-primary)] px-5 py-12 md:px-12 md:py-24">
    <div class="mx-auto max-w-[var(--max-w-page)]">
      <h2
        data-reveal
        class="fade-up mb-10 text-center text-2xl font-medium text-[var(--color-text-primary)] md:mb-14 md:text-4xl"
        style="font-family: var(--font-display)"
      >
        {{ t("whyCresci.heading") }}
      </h2>

      <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
        <div
          v-for="card in primaryCards"
          :key="card.key"
          data-reveal
          :data-reveal-delay="card.delay"
          class="fade-up rounded-[20px] border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-[var(--shadow-card)] md:p-8"
        >
          <UIcon :name="card.icon" class="size-10 text-[var(--color-primary)]" />
          <h3
            class="mt-3 text-lg font-medium text-[var(--color-text-primary)] md:text-xl"
            style="font-family: var(--font-display)"
          >
            {{ t(`whyCresci.cards.${card.key}.title`) }}
          </h3>
          <p class="mt-2 text-sm leading-relaxed text-[var(--color-text-secondary)] md:text-base">
            {{ t(`whyCresci.cards.${card.key}.body`) }}
          </p>
        </div>
      </div>

      <p
        data-reveal
        data-reveal-delay="2"
        class="fade-up mt-10 mb-6 text-center text-sm font-medium uppercase tracking-widest text-[var(--color-text-muted)] md:mt-14 md:mb-8"
      >
        {{ t("whyCresci.andMore") }}
      </p>

      <div class="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        <div
          v-for="item in secondaryItems"
          :key="item.key"
          data-reveal
          :data-reveal-delay="item.delay"
          class="fade-up rounded-[14px] bg-[var(--color-bg-secondary)] p-4 md:p-5"
        >
          <UIcon :name="item.icon" class="size-8 text-[var(--color-primary)]" />
          <h3
            class="mt-2 text-sm font-medium text-[var(--color-text-primary)] md:text-base"
            style="font-family: var(--font-display)"
          >
            {{ t(`whyCresci.secondary.${item.key}.title`) }}
          </h3>
          <p class="mt-1 text-xs leading-relaxed text-[var(--color-text-secondary)] md:text-sm">
            {{ t(`whyCresci.secondary.${item.key}.body`) }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
